import React, { useState } from "react"
import Heading from "./Heading"
import styles from "./chat.module.scss"
import overlayStyles from "./overlay.module.scss"

const Chat = () => {
  const [chatOpen, setChatOpen] = useState(false)

  const handleChatButton = () => {
    setChatOpen(true)
  }

  const handleLivechat = () => {
    document.querySelector(".LPMcontainer").click()
    setChatOpen(false)
  }

  return(
    <>
      <button
        className={(chatOpen) ? styles.buttonHidden : styles.button}
        onClick={handleChatButton}
      >
        Let's Talk
      </button>
      <div
        className={(chatOpen) ? overlayStyles.overlay : ""}
        role="presentation"
        onClick={() => setChatOpen(false)}
      >
      </div>
      <div className={(chatOpen) ? styles.containerOpen : styles.container}>
        <button
          className={`${overlayStyles.closeBtn} ${styles.closeBtn}`}
          onClick={() => setChatOpen(false)}
          title="Close"
        >Close</button>
        <Heading
          tag="h3"
          level="3"
          className={styles.heading}
        >
          Fit Questions?
        </Heading>
        <ul className={styles.options}>
          <li>
            <a
              href="https://bcrw.apple.com/urn:biz:040ab1a9-29a8-4dc5-b791-3616dd7bfdfa"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.abcButton}
            >
              <span>Message Us</span>
            </a>
          </li>
          <li>
            <a
              href="sms:+13109974390"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.smsButton}
            >
              <span>SMS</span>
            </a>
          </li>
          <li>
            <button
              className={styles.webButton}
              onClick={handleLivechat}
            >
              <span>Livechat</span>
            </button>
          </li>
          <li>
            <a
              href="https://m.me/tamaramellonbrand"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.fbButton}
            >
              <span>Facebook</span>
            </a>
          </li>
          <li>
            <a
              href="https://wa.me/13109974390"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.whatsappButton}
            >
              <span>WhatsApp</span>
            </a>
          </li>
        </ul>
      </div>
    </>
  )
}

export default Chat
